<div class="justify-content-lg-end gadget">
  <div class="title">
    <span translate>{{title}}</span>
  </div>
  <div class="pl-2 pt-1">
    <div>
      <div>
        @if (showGadget) {
          <div class="chart">
            <!--
            // TODO: Angular16Fix
            -->
            <!--                    <canvas baseChart-->
            <!--                            [data]="pieChartData"-->
            <!--                            [labels]="pieChartLabels"-->
            <!--                            [type]="pieChartType"-->
            <!--                            [options]="pieChartOptions"-->
            <!--                            [plugins]="pieChartPlugins"-->
            <!--                            [colors]="pieChartColors"-->
            <!--                            [legend]="pieChartLegend">-->
          <!--                    </canvas>-->
          <canvas baseChart
            [data]="pieChartData"
            [labels]="pieChartLabels"
            [type]="pieChartType"
            [options]="pieChartOptions"
            [plugins]="pieChartPlugins"
            [legend]="pieChartLegend">
          </canvas>
        </div>
      }
    </div>
  </div>
  <div>
  </div>
  @if (btnText) {
    <button type="button" class="btn btn-primary" translate (click)="onBtnClick()">{{btnText}}</button>
  }

</div>
</div>
